import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "@mui/material/Tooltip";
import { faBell, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { faRepeat } from "@fortawesome/free-solid-svg-icons";
import SateLiteMenu from "../../mainLayer/satellite/SateLiteMenu";
import WindLayer from "../../mainLayer/weather/wind/WindLayer";
import TempLayer from "../../mainLayer/weather/temperature/TempLayer";
import AccumulatedRainLayer from "../../mainLayer/weather/accumulated/AccumullatedRainLayer";
import AirPressureLayer from "../../mainLayer/weather/airPressure/AirPressureLayer";
import RiverSensors from "../../riverSensors/RiverSensors";
import IncidentsMenu from "../../mainLayer/hazardIncidentsLayers/ReportIncidents";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import AirQuality from "../../mainLayer/airQuality/airQuality";
import EarlyWarning from "../../mainLayer/earlyWarning/EarlyWarning";
import ShowEarlyWarning from "../../mainLayer/earlyWarning/ShowEarlyWarning";
import Flood from "../../mainLayer/flood/Flood";
import SummeryFull from "../../mainLayer/summeryComp/SummeryFull";
import Pressure from "../../mainLayer/weather/pressure/pressure";
import Rainfall from "../../mainLayer/rainfall/Rainfall";
import SensorButton from "../../mainLayer/miniMenu/SensorButton";
import Waves from "../../mainLayer/weather/waveHeight/Waves";
import { useMapLayersContext } from "../../provider/MapLayers";
import RainProbability from "../../mainLayer/weather/rain/RainProbability";

interface TimelineElement {
  id: string;
  stimestamp: number;
  Interval: number;
  edtimestamp: number;
}

interface LeftSideMenuProps {
  // setWeatherLayer: Dispatch<SetStateAction<string>>;
  setTimeLayer: Dispatch<SetStateAction<string>>;
  layerValueFromLeftSideMenu: (value: string) => void;
  showTimeRangeExceedNotification: (show: boolean) => void;
  passStartHazardDuration: (from: string) => void;
  passToHazardDuration: (to: string) => void;
  openPopupLeftSideMenu: (open: boolean) => void;
  clickedHzIncident: boolean;
  showPopupDropDown: boolean;
  getValueFromLefSideMenu: string;
  clickedEWS: boolean;
  timeLineHour: string;
  timeLineDate: string;
  timeIndexCount: number | undefined;
  selectModel: string;
  getVoiceRecognitionValue: string;
  timelineData: TimelineElement[];
  openModular: (value: string) => void;
  setRiverSensorRender: (value: boolean) => void;
  sensorType: (value: string) => void;
  renderAirQualitySensor: (value: boolean) => void;
  sidebarOpen: (value: boolean) => void;
  closePopupDropDown: (open: boolean) => void;
  showPopupDropDownSensor: boolean;
  openLayerTypeMap: Map<string, boolean>;
  minMenuRain: boolean;
  minMenuRiver: boolean;
  minMenuAir: boolean;
  minMenuAirLeft: (open: boolean) => void;
  minMenuRiverLeft: (open: boolean) => void;
  minMenuRainLeft: (open: boolean) => void;
  openPopupDropDown: (open: boolean) => void;
  miniMenuload: boolean;
}

const LeftSideMenu: React.FC<LeftSideMenuProps> = ({
  // setWeatherLayer,
  setTimeLayer,
  layerValueFromLeftSideMenu,
  showTimeRangeExceedNotification,
  passStartHazardDuration,
  passToHazardDuration,
  openPopupLeftSideMenu,
  clickedHzIncident,
  showPopupDropDown,
  getValueFromLefSideMenu,
  clickedEWS,
  timeLineHour,
  timeLineDate,
  timeIndexCount,
  selectModel,
  getVoiceRecognitionValue,
  timelineData,
  openModular,
  setRiverSensorRender,
  sensorType,
  renderAirQualitySensor,
  sidebarOpen,
  closePopupDropDown,
  showPopupDropDownSensor,
  openLayerTypeMap,
  minMenuRain,
  minMenuRiver,
  minMenuAir,
  minMenuAirLeft,
  minMenuRiverLeft,
  minMenuRainLeft,
  openPopupDropDown,
  miniMenuload
}) => {
  const { loadLayerInMap, set1Order } = useMapLayersContext();
  const [getOpenMenu, setGetOpenMenu] = useState<string>("");
  const [endTime, setEndTime] = useState<string>("");
  const [weatherlayerState, setWeatherlayerState] = useState<string>("");
  const [sendTimeIndexCounte, setSendTimeIndexCount] = useState<number>();
  const [getUser, setUser] = useState<string>();
  const [hoveredPressure, setHoveredPressure] = useState(false);
  const [hoveredISO, setHoveredISO] = useState(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [isCheckedPressure, setIsCheckedPressure] = useState(false);
  const [isCheckedISO, setIsCheckedISO] = useState(false);
  const handleChangePressureToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsCheckedPressure(event.target.checked);
    setIsClicked((prevState) => !prevState);
  };

  const handleChangeISOToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsCheckedISO(event.target.checked);
  };

  useEffect(() => { }, [setWeatherlayerState]);

  const handleTimeLayerChange = (layer: string) => {
    console.log("-------11----",layer)
    setTimeLayer(layer);
    setWeatherlayerState(layer);
  };

  useEffect(() => { }, [loadLayerInMap]);
  useEffect(() => { }, [setTimeLayer]);

  useEffect(() => {
    if (getOpenMenu) {
      layerValueFromLeftSideMenu(getOpenMenu);
    }
  }, [getOpenMenu]);

  useEffect(() => {
    if (getValueFromLefSideMenu === "main") {
      setGetOpenMenu(getValueFromLefSideMenu);
    }
  }, [getValueFromLefSideMenu]);

  useEffect(() => {
    setEndTime("2024-06-05");

    // Set the second endTime after 5 seconds
    const timer = setTimeout(() => {
      setEndTime("2024-05-19");
    }, 10000);

    // Clear the timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setSendTimeIndexCount(timeIndexCount);
  }, [timeIndexCount]);

  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     try {
  //       const user = JSON.parse(storedUser);
  //       const username = user.username;
  //       setUser(username);
  //     } catch (error) {
  //       console.error("Error parsing JSON from localStorage:", error);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("username");

    if (storedUser) {
      try {
        //const user = JSON.parse(storedUser);
        //const user = JSON.parse(storedUser)
        //const username = user.username;
        const username = storedUser;
        setUser(username);
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  }, []);

  const buttonConfig = {
    metofficer: [
      { key: "flood", set: "set1" },
      { key: "tides", set: "set1" },
         { key: "rainProbability", set: "set1" },
      { key: "wind", set: "set1" },
      { key: "temperature", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "airPressure", set: "set1" },
      { key: "earlyWarning", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "airquality", set: "set3" },
      { key: "stellite", set: "set3" },

      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    nbroofficer: [
      { key: "flood", set: "set1" },
      { key: "wind", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "rainProbability", set: "set1" },

      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "airquality", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    irrigationofficer: [
      { key: "flood", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "rainProbability", set: "set1" },

      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    gaofficer: [
      { key: "flood", set: "set1" },
      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },
      { key: "rainProbability", set: "set1" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    admin: [
      { key: "tides", set: "set1" },
      { key: "flood", set: "set1" },
      { key: "rainProbability", set: "set1" },
      { key: "wind", set: "set1" },
      { key: "temperature", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "airPressure", set: "set1" },

      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "airquality", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    test: [
      { key: "tides", set: "set1" },
      { key: "flood", set: "set1" },         
      { key: "rainProbability", set: "set1" },
      { key: "wind", set: "set1" },
      { key: "temperature", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "airPressure", set: "set1" },

      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "airquality", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
    mvtest: [
      { key: "tides", set: "set1" },
      { key: "rainProbability", set: "set1" },
      { key: "wind", set: "set1" },
      { key: "temperature", set: "set1" },
      { key: "rain", set: "set1" },
      { key: "airPressure", set: "set1" },

      { key: "earlyWarning", set: "set2" },
      { key: "reportedincidents", set: "set2" },

      { key: "rainfall", set: "set3" },
      { key: "riversensor", set: "set3" },
      { key: "airquality", set: "set3" },
      { key: "stellite", set: "set3" },
      { key: "pressure", set: "set4" },
      { key: "iso", set: "set4" },
    ],
  };

  useEffect(() => { }, [minMenuRain]);
  useEffect(() => { }, [minMenuRiver]);
  useEffect(() => { }, [minMenuAir]);

  const displayButtons = () => {
    const getUserButtonData =
      buttonConfig[getUser as keyof typeof buttonConfig];

    if (!getUserButtonData) return null;

    const set1Buttons = getUserButtonData.filter((btn) => btn.set === "set1");
    const set2Buttons = getUserButtonData.filter((btn) => btn.set === "set2");
    const set3Buttons = getUserButtonData.filter((btn) => btn.set === "set3");

    const set4Buttons = getUserButtonData.filter((btn) => btn.set === "set4");

    // Reorder set1 buttons according to dynamic order
    const orderedSet1Buttons = set1Order
      .map(key => set1Buttons.find(btn => btn.key === key))
      .filter((btn): btn is { key: string; set: string } => btn !== undefined);

    // Combine with other sets that don't need reordering
    const allButtons = [
      ...orderedSet1Buttons,
      ...set2Buttons,
      ...set3Buttons,
      ...set4Buttons
    ];
    return (
      <div
        style={{
          padding: "0.5vh 0",
          display: "flex",
          flexDirection: "column",
        }}
        className="leftsidemenulist-container"
      >
        <div className="my-weatherdiv">
          {orderedSet1Buttons.map(({ key, set }, index) => (
            <div
              className="leftsidemenulist-btns-container"
              key={`first-group-${key}-${index}`}
            >

              {key === "wind" && (
                <WindLayer
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromWind={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  getVoiceRecognitionValue={getVoiceRecognitionValue}
                  timelineData={timelineData}
                  selectModel={selectModel}
                />
              )}

              {key === "temperature" && (
                <TempLayer
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromTemp={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  selectModel={selectModel}
                />
              )}

              {key === "rain" && (
                <AccumulatedRainLayer
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromRain={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  selectModel={selectModel}
                />
              )}

              {key === "airPressure" && (
                <AirPressureLayer
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromAir={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  selectModel={selectModel}
                />
              )}

              {key === "flood" && (
                <Flood
                  senddValueFromFlood={setGetOpenMenu}
                  timeIndexCountFlood={sendTimeIndexCounte}
                  weatherlayerState={weatherlayerState}
                  setTimeLayer={handleTimeLayerChange}
                />
              )}
              {key === "tides" && (
                <Waves
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromTides={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  selectModel={selectModel}
                />
              )}
              {key === "rainProbability" && (
                <RainProbability
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                  senddValueFromTides={setGetOpenMenu}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                  selectModel={selectModel}
                />
              )}
            </div>
          ))}
        </div>
        {set2Buttons.length > 0 && (
          <div
            style={{
              height: "1.5vh",
            }}
          />
        )}
        {getUserButtonData.map(({ key, set }, index) => (
          <div
            className="leftsidemenulist-btns-container"
            key={`first-group-${key}-${index}`}
          >
            {key === "earlyWarning" && (
              <EarlyWarning
                senddValueFromEarlyWarningMenu={setGetOpenMenu}
                openIncidentDropDown={openPopupLeftSideMenu}
                openTitle={getOpenMenu}
                clickedEWS={clickedEWS}
                showPopupDropDown={showPopupDropDown}
              />
            )}

            {key === "reportedincidents" && (
              <IncidentsMenu
                senddValueFromHazardIncidentsMenu={setGetOpenMenu}
                openIncidentDropDown={openPopupLeftSideMenu}
                openTitle={getOpenMenu}
                clickedHzIncident={clickedHzIncident}
                showPopupDropDown={showPopupDropDown}
              />
            )}
          </div>
        ))}

        {set3Buttons.length > 0 && (
          <div
            style={{
              height: "1.5vh",
            }}
          />
        )}
        <div
          className={`left-side-menu-expand-wrapper`}
          style={{
            opacity: (miniMenuload ? 0 : 1),
            pointerEvents: (miniMenuload ? "none" : "auto"),
            transition: "opacity 0.3s ease",
          }}
        >
          {getUserButtonData.map(({ key, set }, index) => (

            <div
              className="leftsidemenulist-btns-container"
              key={`first-group-${key}-${index}`}
            >
              {key === "rainfall" && (
                <Rainfall
                  senddValueFromRainfall={setGetOpenMenu}
                  sensorType={sensorType}
                  openModular={openModular}
                  renderRainfallSensor={renderAirQualitySensor}
                  sidebarOpen={sidebarOpen}
                  minMenuRain={minMenuRain}
                  minMenuRainLeft={minMenuRainLeft}
                />
              )}

              {key === "riversensor" && (
                <RiverSensors
                  senddValueFromRiverSensorMenu={setGetOpenMenu}
                  getVoiceRecognitionValue={getVoiceRecognitionValue}
                  openModular={openModular}
                  setRiverSensorRender={setRiverSensorRender}
                  sensorType={sensorType}
                  sidebarOpen={sidebarOpen}
                  minMenuRiver={minMenuRiver}
                  minMenuRiverLeft={minMenuRiverLeft}
                />
              )}

              {key === "airquality" && (
                <AirQuality
                  senddValueFromAirQuality={setGetOpenMenu}
                  sensorType={sensorType}
                  openModular={openModular}
                  renderAirQualitySensor={renderAirQualitySensor}
                  sidebarOpen={sidebarOpen}
                  minMenuAir={minMenuAir}
                  minMenuAirLeft={minMenuAirLeft}
                />
              )}
              {key === "stellite" && (
                <SateLiteMenu
                  senddValueFromSateliteMenu={setGetOpenMenu}
                  openIncidentDropDown={openPopupLeftSideMenu}
                  openTitle={getOpenMenu}
                  setTimeLayer={handleTimeLayerChange}
                  weatherlayerState={weatherlayerState}
                />
              )}
            </div>
          ))}
        </div>
        <div
          className={`left-side-menu-single-wrapper`}
        >
          <div className="leftsidemenulist-btns-container">
            <SensorButton
              closePopupDropDown={closePopupDropDown}
              showPopupDropDownSensor={showPopupDropDownSensor}
              getOpenMenu={getOpenMenu}
              openLayerTypeMap={openLayerTypeMap}
              openPopupDropDown={openPopupDropDown}
            />
            {getUserButtonData.map(({ key, set }, index) => (
              <div
                className="leftsidemenulist-btns-container"
                key={`first-group-${key}-${index}`}
              >
                {key === "stellite" && (
                  <SateLiteMenu
                    senddValueFromSateliteMenu={setGetOpenMenu}
                    openIncidentDropDown={openPopupLeftSideMenu}
                    openTitle={getOpenMenu}
                    setTimeLayer={handleTimeLayerChange}
                    weatherlayerState={weatherlayerState}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {set4Buttons.length > 0 && (
          <div
            style={{
              height: "1.5vh",
            }}
          />
        )}

        {getUserButtonData.map(({ key, set }, index) => (
          <div
            className="leftsidemenulist-btns-container"
            key={`first-group-${key}-${index}`}
          >
            {key === "pressure" && (
              <Pressure
                timeLineHour={timeLineHour}
                timeLineDate={timeLineDate}
                selectModel={selectModel}
                setTimeLayer={handleTimeLayerChange}
              />
              // <div className="leftsidemenulist-btn-cover">
              //   <div
              //     onMouseEnter={() => setHoveredPressure(true)}
              //     onMouseLeave={() => setHoveredPressure(false)}
              //     className="leftsidemenulist-btns"
              //   >
              //     <FontAwesomeIcon size="1x" icon={faLayerGroup} className="leftside-icon"/>
              //   </div>
              //   <div
              //     className="leftsidemenulist-btn-tooltip"
              //     onMouseEnter={() => setHoveredPressure(true)}
              //     onMouseLeave={() => setHoveredPressure(false)}
              //     style={{
              //       backgroundColor:  isClicked
              //       ? "leftsidemenulist-btn-tooltip-clicked-light"
              //       : hoveredPressure
              //       ? "leftsidemenulist-btn-tooltip-hover-light"
              //       : "leftsidemenulist-btn-tooltip-light",
              //       fontSize: "14px",
              //     }}

              //   >
              //     Pressure
              //   </div>
              //   {hoveredPressure && (
              //     <label
              //       onMouseEnter={() => setHoveredPressure(true)}
              //       onMouseLeave={() => setHoveredPressure(false)}
              //       className="switch"
              //     >
              //       <input
              //         type="checkbox"
              //         role="switch"
              //         checked={isCheckedPressure}
              //         onChange={handleChangePressureToggle}
              //       />
              //       <div className="switch-labels"></div>
              //     </label>
              //   )}
              // </div>
            )}

            {/* {key === "iso" && (
              <div className="leftsidemenulist-btn-cover">
                <div
                  onMouseEnter={() => setHoveredISO(true)}
                  onMouseLeave={() => setHoveredISO(false)}
                  className="leftsidemenulist-btns"
                >
                  <FontAwesomeIcon size="1x" icon={faBell} />
                </div>
                <div
                  className="leftsidemenulist-btn-tooltip"
                  onMouseEnter={() => setHoveredISO(true)}
                  onMouseLeave={() => setHoveredISO(false)}
                  style={{
                    backgroundColor: hoveredISO
                      ? "rgba(0, 0, 0, 0.5)"
                      : "rgba(255, 255, 255, 0.2)",
                    fontSize: "14px",
                  }}
                >
                  ISO
                </div>
                {hoveredISO && (
                  <label
                    onMouseEnter={() => setHoveredISO(true)}
                    onMouseLeave={() => setHoveredISO(false)}
                    className="switch"
                  >
                    <input type="checkbox" role="switch" 
                      checked={isCheckedISO}
                      onChange={handleChangeISOToggle}/>
                    <div className="switch-labels"></div>
                  </label>
                )}
              </div>
            )} */}
          </div>
        ))}
      </div>
    );
  };

  return <div>{displayButtons()}</div>;
};

export default LeftSideMenu;

